export default __webpack_public_path__ + "static/media/banner_chart.67a256b2.svg";